export const PhysicalHealthCondition = {
  NONE: "None",
  KIDNEY_DISEASE: "KidneyDisease",
  COPD: "COPD",
  ASTHMA: "Asthma",
  THYROID_CONDITION: "ThyroidCondition",
  STROKE_OR_TIA: "StrokeOrTIA",
  CHD: "CHD",
  HEART_ATTACK: "HeartAttack",
  ARTHRITIS: "Arthritis",
  DIABETES: "Diabetes",
  HYPERTENSION: "Hypertension",
  HYPERCHOLESTEROLEMIA: "Hypercholesterolemia",
  OTHER: "Other",
};

export const healthConditions = [
  { value: "hypertension", label: "Hypertension" },
  { value: "cardiac", label: "Cardiac disease" },
  { value: "renalDisease", label: "Renal disease" },
  { value: "mentalHealthDisorder", label: "Mental health disorder" },
  { value: "thromboembolicDisorder", label: "Thromboembolic disorder" },
  { value: "haematologicalDisorder", label: "Haematological disorder" },
  { value: "centralNervousSystemDisorder", label: "Central nervous system disorder", },
  { value: "diabetes", label: "Diabetes" },
  { value: "autoimmuneDisease", label: "Autoimmune disease" },
  { value: "cancer", label: "Cancer" },
  { value: "hepatitisA", label: "Infectious hepatitis A" },
  { value: "hepatitisB", label: "Serum hepatitis B" },
  { value: "hepatitisC", label: "Hepatitis C" },
  { value: "endocrineDisorder", label: "Endocrine disorder" },
  { value: "respiratoryDisease", label: "Respiratory disease" },
  { value: "gastrointestinalDisorder", label: "Gastrointestinal disorder" },
  { value: "musculoskeletalDisorder", label: "Musculoskeletal disorder" },
  { value: "other", label: "Other" },
];
